import type { Auth } from "@staffsmith/web-auth";
import { createContext, useContext } from "react";
import type { Api } from "./api.js";

// What every page needs: the API client and sign-in, and whether this
// environment offers password sign-in (dev demo sign-ins only).
export type AppServices = { api: Api; auth: Auth; allowPassword: boolean; apiUrl?: string };

export const Services = createContext<AppServices | null>(null);

export function useServices(): AppServices {
  const services = useContext(Services);
  if (!services) throw new Error("useServices outside <Services.Provider>");
  return services;
}

export const useApi = () => useServices().api;
